var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeehealthWhiteMin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 40,
    viewBox: "0 0 75 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 13C30.0941 13 24 19.0941 24 26.5C24 33.9059 30.0941 40 37.5 40C44.9059 40 51 33.9059 51 26.5C51 19.0941 44.9059 13 37.5 13ZM44.5176 28.8416H39.8367V33.52H35.1731V28.8416H30.4825V24.1657H35.1608V19.4874H39.8244V24.1657H44.5028L44.5176 28.8416V28.8416Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6251 26.8276L0.000549316 24.4982C0.401604 23.5174 10.1223 0.618652 37.2987 0.618652C64.475 0.618652 74.1957 23.5224 74.5968 24.4982L68.9722 26.8202L71.7845 25.6506L68.982 26.8276C68.6397 26.0062 60.33 6.72157 37.3036 6.72157C14.2771 6.72157 5.96747 25.9988 5.6251 26.8276V26.8276Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeehealthWhiteMin);
export default __webpack_public_path__ + "static/media/seehealth_white_min.8c29f6b5fb0f4d880a072f9b86d93682.svg";
export { ForwardRef as ReactComponent };